import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "@/components/ScrollToTop";
import { CookieConsentProvider } from "@/contexts/CookieConsentContext";
import { CookieConsentWrapper } from "@/components/CookieConsentWrapper";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { GoogleAnalytics } from "@/components/GoogleAnalytics";
import Index from "./pages/Index";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Insights from "./pages/Insights";
import ArticleDetail from "./pages/ArticleDetail";
import Resources from "./pages/Resources";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Location from "./pages/Location";
import Locations from "./pages/Locations";
import BlogPostMaster from "./pages/BlogPostMaster";
import BlogSpeed from "./pages/BlogSpeed";
import BlogPlatforms from "./pages/BlogPlatforms";
import BlogAccessibility from "./pages/BlogAccessibility";
import BlogLocalSeo from "./pages/BlogLocalSeo";
import BlogMobile from "./pages/BlogMobile";
import BlogReviews from "./pages/BlogReviews";
import BlogFuture from "./pages/BlogFuture";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <CookieConsentProvider>
        <GoogleAnalytics />
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <CookieConsentWrapper />
            <WhatsAppButton />
            <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<ArticleDetail />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locations/:slug" element={<Location />} />
            <Route path="/blog-post-master" element={<BlogPostMaster />} />
            <Route path="/blog-speed" element={<BlogSpeed />} />
            <Route path="/blog-platforms" element={<BlogPlatforms />} />
            <Route path="/blog-accessibility" element={<BlogAccessibility />} />
            <Route path="/blog-localseo" element={<BlogLocalSeo />} />
            <Route path="/blog-mobile" element={<BlogMobile />} />
            <Route path="/blog-reviews" element={<BlogReviews />} />
            <Route path="/blog-future" element={<BlogFuture />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </CookieConsentProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
